// Template ids for Portfolio Story and Final Portfolio Story (see _data.ts slidesComponents).
const PORTFOLIO_STORY_TEMPLATE_IDS = new Set([20, 27]);

// Matches API-generated titles like "Portfolio Story for <Model>".
const PORTFOLIO_STORY_TITLE_MARKER = 'portfolio story for';

function getSlideTitleString(content: unknown): string {
  if (!Array.isArray(content)) return '';
  for (const item of content) {
    if (
      item &&
      typeof item === 'object' &&
      'field' in item &&
      (item as { field: string }).field === 'title' &&
      'value' in item
    ) {
      const v = (item as { value: unknown }).value;
      if (typeof v === 'string') return v;
    }
  }
  return '';
}

export function isPortfolioStorySlide(slide: {
  id?: number;
  content?: unknown;
}): boolean {
  if (
    typeof slide.id === 'number' &&
    PORTFOLIO_STORY_TEMPLATE_IDS.has(slide.id)
  ) {
    return true;
  }
  const title = getSlideTitleString(slide.content);
  return title.toLowerCase().includes(PORTFOLIO_STORY_TITLE_MARKER);
}

export function filterOutPortfolioStorySlides<
  T extends { id?: number; content?: unknown },
>(slides: T[] | undefined | null): T[] {
  return (slides || []).filter(s => !isPortfolioStorySlide(s));
}
